import React, { useMemo } from 'react';
import { Select } from 'antd';
import useFormatMessage from 'hooks/useFormatMessage';
import useMatomoGoalOptions, { normalizeMatomoGoalCompositeId } from 'hooks/useMatomoGoalOptions';
import goalMessages from 'components/DimensionValue/messages';

const GoalSelector = ({ value, onChange, customerId }) => {
  const $t = useFormatMessage();
  const { groupedOptions, goalById, loading } = useMatomoGoalOptions(customerId);
  const normalizedValue = normalizeMatomoGoalCompositeId(value);

  const deletedGoalLabel = $t(goalMessages.deletedGoal);

  const selectOptions = useMemo(() => {
    if (normalizedValue == null || goalById[normalizedValue]) {
      return groupedOptions;
    }
    return [
      ...groupedOptions,
      {
        label: deletedGoalLabel,
        options: [{ label: <em>{deletedGoalLabel}</em>, value: normalizedValue }],
      },
    ];
  }, [groupedOptions, goalById, normalizedValue, deletedGoalLabel]);

  return (
    <Select
      options={selectOptions}
      value={normalizedValue}
      onChange={onChange}
      loading={loading}
      style={{ minWidth: 200 }}
      showSearch
      optionFilterProp="label"
    />
  );
};

export default GoalSelector;
